<div class="info-bar" role="region" aria-label="Dados do paciente em atendimento">
  @if (store.carregandoEntrada()) {
    <div class="info-bar__grid">
      @for (campo of camposSkeleton; track campo) {
        <div class="info-bar__campo">
          <p-skeleton width="4rem" height="0.6rem" styleClass="mb-2" />
          <p-skeleton width="7.5rem" height="0.85rem" />
        </div>
        @if (campo < camposSkeleton.length) {
          <div class="info-bar__divisor" aria-hidden="true"></div>
        }
      }
    </div>
  } @else if (store.entrada(); as entrada) {
    <div class="info-bar__grid">
      <div
        class="info-bar__campo info-bar__campo--id"
        pTooltip="ID da entrada do paciente"
        tooltipPosition="bottom"
      >
        <span class="info-bar__rotulo">ID Entrada</span>
        <span class="info-bar__valor info-bar__valor--destaque">#{{ entrada.id }}</span>
      </div>

      <div class="info-bar__divisor" aria-hidden="true"></div>

      <div
        class="info-bar__campo info-bar__campo--nome"
        [pTooltip]="entrada.paciente.nomeCivil || ''"
        tooltipPosition="bottom"
      >
        <span class="info-bar__rotulo">Paciente</span>
        <span class="info-bar__valor">{{ entrada.paciente.nomeCivil || '—' }}</span>
      </div>

      <div class="info-bar__divisor" aria-hidden="true"></div>

      <div
        class="info-bar__campo"
        [pTooltip]="obterDataNascimentoComIdade(entrada)"
        tooltipPosition="bottom"
      >
        <span class="info-bar__rotulo">Nasc. / Idade</span>
        <span class="info-bar__valor">{{ obterDataNascimentoComIdade(entrada) }}</span>
      </div>

      <div class="info-bar__divisor" aria-hidden="true"></div>

      <div
        class="info-bar__campo"
        [pTooltip]="entrada.area.nome || ''"
        tooltipPosition="bottom"
      >
        <span class="info-bar__rotulo">Área</span>
        <span class="info-bar__valor">{{ entrada.area.nome || '—' }}</span>
      </div>

      <div class="info-bar__divisor" aria-hidden="true"></div>

      <div
        class="info-bar__campo"
        [pTooltip]="obterNomeLeito(entrada)"
        tooltipPosition="bottom"
      >
        <span class="info-bar__rotulo">Leito</span>
        <span class="info-bar__valor info-bar__valor--leito">{{ obterNomeLeito(entrada) }}</span>
      </div>
    </div>
  }
</div>
